import * as React from 'react';
import { pluralize } from '@cian/newbuilding-utils';
import { ArticleHeading1, InlineText2 } from '@cian/ui-kit/typography';
import { useSelector } from 'react-redux';
import { trackDocumentClick } from './tracking';
import { Documents } from '../../components/Documents';
import { LinkList } from '../../components/LinkList';
import { ToggleButton } from '../../components/ToggleButton';
import { getDocuments } from '../../selectors/newbuilding';
import { reliabilityEnabledSelector } from '../../selectors/reliability';

const DESKTOP_VISIBLE_DOCUMENTS_LENGTH = 4;

export function DocumentsContainer() {
  const [isOpened, setOpenedState] = React.useState(false);
  const reliabilityV2Enabled = useSelector(reliabilityEnabledSelector);
  const documents = useSelector(getDocuments);

  const visibleDocumentsLength = isOpened
    ? documents.length
    : documents.slice(0, DESKTOP_VISIBLE_DOCUMENTS_LENGTH).length;
  const hiddenDocumentsLength = documents.length - visibleDocumentsLength;
  const shouldShowButton = documents.length - DESKTOP_VISIBLE_DOCUMENTS_LENGTH > 0;

  const togglerText = isOpened
    ? 'Свернуть'
    : `Ещё ${pluralize(hiddenDocumentsLength, ['документ', 'документа', 'документов'])}`;

  const onChangeOpenedState = React.useCallback(() => setOpenedState(!isOpened), [isOpened, setOpenedState]);

  if (!documents.length || reliabilityV2Enabled) {
    return null;
  }

  return (
    <Documents
      header={
        <ArticleHeading1 as="h2" fontWeight={'bold'}>
          Проектная документация
        </ArticleHeading1>
      }
      list={<LinkList isOpened={isOpened} links={documents} cols={2} onLinkClick={trackDocumentClick} />}
      toggler={
        shouldShowButton ? (
          <ToggleButton onClick={onChangeOpenedState} isOpened={isOpened}>
            <InlineText2 color="text-main-default">{togglerText}</InlineText2>
          </ToggleButton>
        ) : null
      }
    />
  );
}
